import React from 'react';

const CFG = {
  OK      : { bg: '#ecfdf5', border: '#a7f3d0', color: '#059669', icon: '✔', title: 'All Clear',      grad: 'linear-gradient(90deg, #ecfdf5, #f0fdf4)' },
  WARNING : { bg: '#fffbeb', border: '#fde68a', color: '#d97706', icon: '⚠', title: 'Warning',         grad: 'linear-gradient(90deg, #fffbeb, #fef9c3)' },
  CRITICAL: { bg: '#fff1f2', border: '#fecaca', color: '#dc2626', icon: '⚡', title: 'Critical Alert',  grad: 'linear-gradient(90deg, #fff1f2, #ffe4e6)' },
  MOTION  : { bg: '#eff6ff', border: '#bfdbfe', color: '#2563eb', icon: '↗', title: 'Motion Detected', grad: 'linear-gradient(90deg, #eff6ff, #dbeafe)' },
};

export default function AlertBanner({ level, msg }) {
  const cfg = CFG[level] ?? CFG.OK;

  return (
    <div style={{
      ...s.banner,
      background  : cfg.grad,
      borderColor : cfg.border,
    }}>
      {/* Left icon */}
      <div style={{ ...s.iconCircle, background: cfg.color + '18', border: `1.5px solid ${cfg.border}` }}>
        <span style={{ ...s.iconText, color: cfg.color }}>{cfg.icon}</span>
      </div>

      {/* Text */}
      <div style={s.textBlock}>
        <span style={{ ...s.levelText, color: cfg.color }}>{cfg.title}</span>
        <span style={s.msgText}>{msg}</span>
      </div>

      {/* Level badge */}
      <div style={{ ...s.levelBadge, background: cfg.color + '15', color: cfg.color, border: `1px solid ${cfg.border}` }}>
        {level}
      </div>
    </div>
  );
}

const s = {
  banner: {
    display     : 'flex',
    alignItems  : 'center',
    gap         : 14,
    border      : '1px solid',
    borderRadius: 16,
    padding     : '14px 18px',
    animation   : 'slide-in .3s ease',
    boxShadow   : '0 2px 12px rgba(0,0,0,0.04)',
  },
  iconCircle: {
    width       : 38,
    height      : 38,
    borderRadius: '50%',
    display     : 'flex',
    alignItems  : 'center',
    justifyContent: 'center',
    flexShrink  : 0,
  },
  iconText  : { fontSize: 17, fontWeight: 700 },
  textBlock : { flex: 1, display: 'flex', flexDirection: 'column', gap: 2 },
  levelText : { fontSize: 13, fontWeight: 700 },
  msgText   : { fontSize: 12, color: '#6b7280', fontWeight: 500 },
  levelBadge: {
    fontSize    : 11,
    fontWeight  : 700,
    padding     : '5px 12px',
    borderRadius: 99,
    letterSpacing: '0.06em',
    flexShrink  : 0,
  },
};
